import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// The equipment master (Equipment page), fetched once and shared: the Equipment I.D. box on the production sheets uses it.
let cache = null;
let pending = null;
const load = () => (pending ||= api.get("/equipment", { params: { limit: 500, active_only: true } }).then(({ data }) => (cache = data)).catch(() => (cache = [])).finally(() => { pending = null; }));

/** Active equipment, optionally only of the given types (e.g. ["Press"]). */
export function useEquipment(types) {
  const [rows, setRows] = useState(cache || []);
  useEffect(() => { load().then(setRows); }, []);
  return rows.filter((e) => !types || types.includes(e.equip_type));
}
